/*
 * 参加用の QR とルームコード。
 *
 * 画面ではなくパネル自身の幅で大きさを決める（コンテナクエリ）。パネルは画面の向きや
 * 卓の配置によって幅が変わるため、画面幅のメディアクエリでは合わせきれない。
 */

.panel {
  container-type: inline-size;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-md);
}

/* スマホのカメラで読む対象なので、文字より優先して大きく取る。 */
.qr {
  flex: none;
  width: clamp(6rem, 40cqi, 10rem);
  aspect-ratio: 1;
}

/*
 * 「スマホで / 読み取って参加」の切れ目でだけ折り返す。日本語は任意の文字の間で
 * 折り返すため、そのままだと「参 / 加」のように1文字だけ次の行へ落ちる。
 */
.phrase {
  display: inline-block;
}

/*
 * 文字の列。flex アイテムは既定で中身より縮まないため min-width を 0 にする。これが無いと
 * ルームコードの幅でパネルを突き破る。
 */
.text {
  flex: 1;
  min-width: 0;
  /* ルームコードの大きさを、この列の幅から決めるための基準。 */
  container-type: inline-size;
}

.code {
  /* 6文字 + 字間で、列の幅の 9割弱に収まる大きさ。 */
  font-size: clamp(1.25rem, 18cqi, 3.2rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.12em;
  white-space: nowrap;
}

.url {
  overflow-wrap: anywhere;
}

/* 狭いパネルでは縦に積む。QR を横に置くと文字の列が細くなりすぎる。 */
@container (max-width: 17rem) {
  .row {
    flex-direction: column;
    text-align: center;
  }

  .qr {
    width: min(9rem, 60cqi);
  }

  .text {
    width: 100%;
  }
}
